import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import {
  features,
  dateStyle,
  language
} from '../config';
import Firebase from '../api/Firebase';

export default function Users() {
  // const { api } = useContext(FirebaseContext);
  const { api } = Firebase;
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
  } = api;
  const [data, setData] = useState([]);
  const usersdata = useSelector(state => state.usersdata);
  const dispatch = useDispatch();

  useEffect(() => {
    if (usersdata.users) {
      setData(usersdata.users.filter(user => user.usertype === 'fleetadmin'));
    } else {
      setData([]);
    }
  }, [usersdata.users]);

  const columns = [
    { title: language.createdAt, field: 'createdAt', editable: 'never', defaultSort: 'desc', render: rowData => rowData.createdAt ? new Date(rowData.createdAt).toLocaleString(dateStyle) : null },
    { title: language.first_name, field: 'firstName', initialEditValue: '' },
    { title: language.last_name, field: 'lastName', initialEditValue: '' },
    { title: language.email, field: 'email', editable: 'onAdd' },
    { title: language.mobile, field: 'mobile', editable: 'onAdd' },
    // { title: language.profile_image, field: 'profileImage', render: rowData => rowData.profileImage ? <img alt='Profile' src={rowData.profileImage} style={{ width: 50, borderRadius: '50%' }} /> : null, editable: 'never' },
    { title: language.account_approve, field: 'approved', type: 'boolean', initialEditValue: true }
  ];

  return (
    usersdata.loading ? <CircularLoading /> :
      <MaterialTable
        title={language.fleetadmins}
        columns={columns}
        data={data}
        options={{
          exportButton: true,
          sorting: true,
          pageSize: 10
        }}
        editable={{
          onRowAdd: newData =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                checkUserExists(newData).then((res) => {
                  if (res.success) {
                    if (res.data) {
                      alert(language.user_exists);
                      reject();
                    } else {
                      const formData = new FormData();
                      for (let key in newData) {
                        if (key != "mobile") {
                          formData.append(key, newData[key]);
                        }
                      }
                      formData.append('createdByAdmin', true);
                      formData.append('usertype', 'fleetadmin');
                      formData.append('mobile', "+91" + newData['mobile']);
                      // formData.append('referralId', newData.firstName.toLowerCase() + Math.floor(1000 + Math.random() * 9000).toString());
                      // newData['createdAt'] = new Date().toISOString();
                      // newData['referralId'] = newData.firstName.toLowerCase() + Math.floor(1000 + Math.random() * 9000).toString();
                      dispatch(addUser(formData));
                      resolve();
                    }
                  } else {
                    alert(language.email_or_mobile_issue);
                    reject();
                  }
                });
              }, 600);
            }),
          onRowUpdate: (newData, oldData) =>
            new Promise(resolve => {
              const formData = new FormData();
              for (let key in newData) {
                formData.append(key, newData[key]);
              }
              setTimeout(() => {
                resolve();
                dispatch(editUser(oldData.id, formData));
              }, 600);
            }),
          onRowDelete: oldData =>
            features.AllowCriticalEditsAdmin ?
              new Promise(resolve => {
                setTimeout(() => {
                  resolve();
                  dispatch(deleteUser(oldData.id));
                }, 600);
              })
              :
              new Promise(resolve => {
                setTimeout(() => {
                  resolve();
                  alert(language.demo_mode);
                }, 600);
              })
          ,
        }}
      />
  );
}
